import React, { useState, useEffect, useCallback } from 'react';

import Tooltip from '../../../../../Tooltip';
import Textarea from '../../../../../Form/Textarea';

import DropdownClassic from '../../../../../DropdownClassic';
import LoanService from '../../../../../../services/LoanService';

import { useUiContext } from '../../../../../../context/UiContext';

let timer;

export default function OnboardingItem({ item, refetch, loanId }) {
  const [currentOption, setCurrentOption] = useState(item.status);
  const [notes, setNotes] = useState(item.notes);

  const { showToast } = useUiContext();

  const updateStatus = useCallback(
    async (successMessage) => {
      try {
        if (currentOption === item.status && notes === item.notes) {
          return;
        }

        await LoanService.updateLoanOnboarding({
          loanId,
          onboardingId: item.onboarding_id,
          status: currentOption,
          notes,
        });
        refetch();
        showToast({
          text: successMessage,
          type: 'success',
        });
      } catch (error) {
        console.error(error);
        showToast({
          text: error?.response?.data?.message || 'Something went wrong',
          type: 'error',
        });
      }
    },
    [
      currentOption,
      item.notes,
      item.onboarding_id,
      item.status,
      loanId,
      notes,
      refetch,
      showToast,
    ]
  );

  // Update notes on change with debounce
  useEffect(() => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (notes !== item.notes) {
        updateStatus('Onboarding notes updated successfully');
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [item.notes, notes, updateStatus]);

  // Update status on change
  useEffect(() => {
    if (currentOption !== item.status) {
      updateStatus('Onboarding status updated successfully');
    }
  }, [currentOption, item.status, updateStatus]);

  return (
    <div className="md:grid grid-cols-[2fr_3fr_3fr] flex flex-col gap-2 md:gap-6 md:items-start">
      <div className="flex items-center gap-2">
        <span className="whitespace-nowrap">{item._onboarding?.name}</span>
        <Tooltip size="lg" position="right">
          {item._onboarding?.description}
        </Tooltip>
      </div>
      <Textarea
        value={notes}
        onChange={(event) => setNotes(event.target.value)}
      />
      <DropdownClassic
        value={currentOption}
        setFieldValue={(_, value) => setCurrentOption(value)}
        options={[
          { label: 'Pending', value: 'pending' },
          { label: 'Complete', value: 'complete' },
          { label: 'Problem', value: 'problem' },
          { label: 'Not reviewed', value: 'not reviewed' },
        ]}
      />
    </div>
  );
}
